export default () => {
  const html = document.querySelector('html');
  const body = document.querySelector('body');
  const navMenu = document.querySelectorAll('[data-nav-menu]');
  const mnavHamburger = document.querySelector('[data-mnav-hamburger]');
  const mnav = document.querySelector('[data-mnav]');
  const mnavOverlayClose = document.querySelector('.mnav--overlay');
  const mnavClose = document.querySelectorAll('[data-mnav-close]');
  const mobileSubNav = document.querySelectorAll('[data-mnav-menu]');
  const mobileSubNavBack = document.querySelectorAll('[data-mnav-back]');
  const headerSection = document.querySelector('.header__section');
  const stickyHeaderElement = document.querySelector('.stickyHeader');
  let isScrolling = false;

  if (navMenu !== null) {
    navMenu.forEach((element) => {
      document.addEventListener('scroll', () => {
        isScrolling = true;
        element.classList.remove('is-open');
        element.querySelector('.navMegaMenu').classList.remove('delay-hover');
  
        clearTimeout(element.scrollTimeout);
        element.scrollTimeout = setTimeout(() => {
          isScrolling = false;
        }, 150);
      });
  
      element.addEventListener('mouseover', () => {
        if (!isScrolling) {
          if (!element.classList.contains('navMegaMenu')) {
            document.querySelector('.navMegaMenu').classList.remove('delay-hover');
          }
          element.classList.add('is-open');
          element.querySelector('.navMegaMenu').classList.add('delay-hover');
        }
      });
  
      element.addEventListener('mouseout', () => {
        element.classList.remove('is-open');
      });
    });
  }

  if (mnavHamburger !== null) {
    mnavHamburger.addEventListener('click', function (e) {
      e.preventDefault();
      mnav.classList.add('is-active');
      html.classList.add('hidden');
      body.classList.add('hidden');
    });
  }


  if (mnavClose !== null) {
    mnavClose.forEach((item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        mnav.classList.remove('is-active');
        html.classList.remove('hidden');
        body.classList.remove('hidden');
        mobileSubNav.forEach((item) => {
          item.nextElementSibling.classList.remove('is-open');
        });
      });
    });
  }

  if (mnavOverlayClose !== null) {
    mnavOverlayClose.addEventListener('click', function (e) {
      e.preventDefault();
      mnav.classList.remove('is-active');
      html.classList.remove('hidden');
      body.classList.remove('hidden');
    });
  }  
  
  
  if (mobileSubNav !== null) {
    mobileSubNav.forEach((item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        item.nextElementSibling.classList.add('is-open');
      });
    });
  }

  if (mobileSubNavBack !== null) {
    mobileSubNavBack.forEach((item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        item.closest('.mnavmenu__level1').classList.remove('is-open');
      });
    });
  }

  const stickyWatch = (entries) => {
    entries.forEach(entry => {
       headerSection.classList.toggle('header__section--sticky' , !entry.isIntersecting )
    });
  };
  const stickyWatchObserver = new IntersectionObserver(stickyWatch);
  stickyWatchObserver.observe(stickyHeaderElement);  

  headerSection.classList.toggle('header__section--top' , document.cookie.indexOf("announcement-bar=") < 0);
 
}